import React, { useState, useContext } from "react";
import { Paths } from "Paths";
import { useHistory, useRouteMatch } from "react-router-dom";
import { Avatar, Button, CssBaseline, TextField, Typography, Container, makeStyles, Theme } from "@material-ui/core";
import { SigninApi } from "api/SigninApi";
import { SigninContext } from "pages/signin/SigninContext";
import "common.css";

const useStyles = makeStyles((theme: Theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: `flex`,
        flexDirection: `column`,
        alignItems: `center`,
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: `100%`, // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export const Signin: React.FC = () => {
    const classes = useStyles();
    const history = useHistory();
    const match = useRouteMatch(Paths.signin);
    const [inputUserId, setInputUserId] = useState<string>(``); // フォームに入力されたユーザID
    const [inputPassword, setInputPassword] = useState<string>(``); // フォームに入力されたパスワード
    const [errorMessage, setErrorMessage] = useState<string>(``); // エラーメッセージ
    const { setSuccess } = useContext(SigninContext);

    const onClick = async () => {
        // 認証処理
        const result = await SigninApi.signin(inputUserId, inputPassword);
        if (result?.status === 200) {
            setSuccess(true);
            // ログイン画面へリダイレクトされている状態の場合、トップ画面へ遷移する
            // if (match) {
                history.push(Paths.top);
            // }
        } else {
            setErrorMessage(`ユーザIDまたはパスワードに誤りがあります。`);
        }
    };

    /**
     * 入力フォームからカーソルが外れたタイミングで入力値をステートに保持
     * @param event
     */
    const handleBlur = (event: any) => {
        const id = event.target.id;
        const value = event.target.value;
        if (id === `userid`) {
            setInputUserId(value);
        } else if (id === `password`) {
            setInputPassword(value);
        }
    };

    return (
        <div>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}></Avatar>
                    <Typography component="h1" variant="h5">
                        Sign in
                    </Typography>
                    <div className={classes.form}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="userid"
                            label="User ID"
                            name="userid"
                            autoComplete="userid"
                            autoFocus
                            onBlur={handleBlur}
                            onChange={handleBlur}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            onBlur={handleBlur}
                            onChange={handleBlur}
                        />
                        <p className="error">{errorMessage}</p>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={onClick}
                        >
                            Sign In
                        </Button>
                    </div>
                </div>
            </Container>
        </div>
    );
};
